import React from "react";
import { css } from "emotion";
import TopBar from "./TopBar";

const layoutWrapperStyles = css`
  padding: 100px 20px 20px 96px;
`;

const headerStyles = css`
  margin: 0 0 16px;
`;

const messageStyles = css`
  margin: 0 0 16px;
`;

interface IProps {
  header: string;
  message: string;
  isOnline?: boolean;
}

const PageLayout: React.FC<IProps> = ({ header, message }) => (
  <>
    <TopBar />
    <div className={layoutWrapperStyles}>
      <h1 className={headerStyles}>{header}</h1>
      <p className={messageStyles}>{message}</p>
    </div>
  </>
);

export default PageLayout;
